import request from '@/utils/request'

export async function getData(params) {
  return request({
    url: '/statistics/application/counts',
    method: 'get',
    params,
  })
}
export async function exportReport(params) {
  return request({
    url: '/statistics/application/countsExport',
    method: 'get',
    params,
  })
}
